<template>
    <b-row class="my-3">
        <b-col v-for="data in cardData" :md="3" sm="6">
            <b-card class="h-100 text-center">
                <span class="font-size-xs pb-1">{{ data.label }}</span>
                <div class="d-flex flex-column align-items-center justify-content-center h-100">
                    <h1 v-for="value in data.value" class="pb-1">{{ value }}</h1>
                </div>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
export default {
    name: "monthlyTotalCard",
    props: ['invoiceCount', 'invoiceAmountAed', 'invoiceAmountUsd', 'paymentCount', 'paymentAmountAed', 'paymentAmountUsd'],
    computed: {
        cardData: function () {
            return [
                {
                    label: "Total Invoices",
                    value: [this.invoiceCount]
                },
                {
                    label: "Total Invoice Volumes",
                    value: [this.formatCurrency(this.invoiceAmountAed) + " AED", this.formatCurrency(this.invoiceAmountUsd) + " USD"]
                },
                {
                    label: "Total Payments",
                    value: [this.paymentCount]
                },
                {
                    label: "Total Payment Volumes",
                    value: [this.formatCurrency(this.paymentAmountAed) + " AED", this.formatCurrency(this.paymentAmountUsd) + " USD"]
                }
            ]
        }
    },
    methods: {
        formatCurrency(amount) {
            const formattedAmount = new Intl.NumberFormat("en-US", {
                style: "decimal",
                roundingIncrement: 1,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                notation: 'compact'
            }).format(amount.toString());
            return formattedAmount
        },
    }
}
</script>